import React from 'react';

// Subtle hexagonal molecule motif — pharma / chemistry signature
export function MoleculeMark({ size = 140, color = 'currentColor', opacity = 0.35 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 200 200" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ opacity }}>
      <g stroke={color} strokeWidth="1.2">
        <polygon points="100,20 160,55 160,125 100,160 40,125 40,55" />
        <polygon points="100,55 135,75 135,115 100,135 65,115 65,75" />
      </g>
      <g fill={color}>
        <circle cx="100" cy="20" r="4" />
        <circle cx="160" cy="55" r="4" />
        <circle cx="160" cy="125" r="4" />
        <circle cx="100" cy="160" r="4" />
        <circle cx="40" cy="125" r="4" />
        <circle cx="40" cy="55" r="4" />
        <circle cx="100" cy="55" r="3" />
        <circle cx="135" cy="75" r="3" />
        <circle cx="135" cy="115" r="3" />
        <circle cx="100" cy="135" r="3" />
        <circle cx="65" cy="115" r="3" />
        <circle cx="65" cy="75" r="3" />
      </g>
      <g stroke={color} strokeWidth="1.2">
        <line x1="100" y1="20"  x2="100" y2="55" />
        <line x1="160" y1="55"  x2="135" y2="75" />
        <line x1="160" y1="125" x2="135" y2="115" />
        <line x1="100" y1="160" x2="100" y2="135" />
        <line x1="40"  y1="125" x2="65"  y2="115" />
        <line x1="40"  y1="55"  x2="65"  y2="75" />
      </g>
    </svg>
  );
}

// Compact regulatory certification badge
export function CertBadge({ code, label, hint }) {
  return (
    <div className="mm-cert" data-testid={`cert-${code.toLowerCase()}`}>
      <div className="mm-cert-code">{code}</div>
      <div className="mm-cert-body">
        <div className="mm-cert-label">{label}</div>
        <div className="mm-cert-hint">{hint}</div>
      </div>
    </div>
  );
}
